import { NgxCloseSidebarDirective } from './directives/ngx-close-sidebar';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSidebarContainerComponent } from './ngx-sidebar-container/ngx-sidebar-container.component';
import { NgxSidebarComponent } from './ngx-sidebar/ngx-sidebar.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NgxSidebarContainerComponent, NgxSidebarComponent, NgxCloseSidebarDirective],
  exports: [NgxSidebarContainerComponent, NgxSidebarComponent, NgxCloseSidebarDirective]
})
export class NgxUiSidebarContentModule { }
